module.exports = __webpack_public_path__ + "static/img/index-menu-5.24035d2a.png";